// utils/fetchFromMongoDB.js
const isDev = process.env.NODE_ENV === "development";
    // const isProd = process.env.NODE_ENV === "production";
    const baseUrl = isDev
    ? process.env.NEXT_PUBLIC_BASE_URL
    : process.env.NEXT_PUBLIC_PROD_URL;
   
    
// Fetch distinct state names
export const fetchStates = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/states`);
    const data = await response.json();
    return data?.states || [];
  } catch (error) {
    console.error("Error fetching states:", error);
    return [];
  }
};

// Fetch data for a specific state
export const fetchStateData = async (state) => {
  try {
    const response = await fetch(`${baseUrl}/api/states/${state}`);
    const data = await response.json();
    // console.log(data, 'coming from utils folder')
    return data?.stateData || [];
  } catch (error) {
    console.error(`Error fetching data for state ${state}:`, error);
    return [];
  }
};

// // Fetch distinct areas within a state
export const fetchAreas = async (state) => {
  try {
    const response = await fetch(`${baseUrl}/api/states/${state}/areas`);
    const data = await response.json();
    // console.log(data, 'from utils folder')
    return data?.areaData || [];
  } catch (error) {
    console.error(`Error fetching areas for state ${state}:`, error);
    return [];
  }
};

// Fetch a specific business by ID
export const fetchBusiness = async (businessId) => {
  try {
    const response = await fetch(`${baseUrl}/api/business/${businessId}`);
    const data = await response.json();
    return data || null;
  } catch (error) {
    console.error(`Error fetching business with ID ${businessId}:`, error);
    return null;
  }
};



// const fetchFromMongoDB = async () => {
//   try {
//     const isDev = process.env.NODE_ENV === "development";
//     // const isProd = process.env.NODE_ENV === "production";
//     const baseUrl = isDev
//     ? process.env.NEXT_PUBLIC_BASE_URL
//     : process.env.NEXT_PUBLIC_PROD_URL;
//     console.log('check env', baseUrl)
//     const response = await fetch(`${baseUrl}/api/mongo`);


//     if (!response.ok) {
//       throw new Error("Network response was not ok");
//     }
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("Error fetching data from MongoDB:", error);
//     return null;
//   }
// };

// export default fetchFromMongoDB;
